/////////////////wconcept
export interface IDashboardGroupDB {
	groupId: number;
	groupMonth: string;
}

export interface IMissionStatusDB {
	missionNumber: number;
	productPurchase: {
		completed: number;
	};
	draftSend?: {
		completed: number;
	};
	reelsUpload: {
		completed: number;
		notStarted: number;
	};
	styleClipUpload: {
		completed: number;
		notStarted: number;
	};
}
export interface IDashboardGroupSummaryDB {
	memberStatus: {
		totalMembers: number;
		selectedMembers: number;
		contractedMembers: number;
	};
	contentStatus: {
		reels: {
			scheduledContent: number;
			uploadedContent: number;
		};
		styleClips: {
			scheduledContent: number;
			uploadedContent: number;
		};
	};
	missionStatus: IMissionStatusDB[];
}

interface PerformanceData {
	date: string; // YYYY-MM-DD 형식의 날짜
	value: number; // 성과 값
}

export interface IDailyPerformanceDB {
	totalPerformanceScore: PerformanceData[]; // 총 성과 점수
	reelsLikeCount: PerformanceData[]; // 좋아요 수
	styleClipLikeCount: PerformanceData[]; // 좋아요 수
	commentCount: PerformanceData[]; // 댓글 수
	viewCount: PerformanceData[]; // 조회 수
	sentCount: PerformanceData[]; // 쓰는 수
	clickCount: PerformanceData[]; // 클릭 수
}

export interface IGroupsPerformances {
	avgReelsLikeCount: number | null;
	avgStyleClipLikeCount: number | null;
	avgCommentCount: number | null;
	avgViewCount: number | null;
	avgEngagement: number | null;
	avgSentCount: number | null;
	avgClickCount: number | null;
	totalAdvertisingCost: number | null;
	CPV: number | null;
	CPE: number | null;
}
export type GroupPerformanceKeys =
	| keyof Omit<IGroupsPerformances, 'avgReelsLikeCount' | 'avgStyleClipLikeCount'>
	| 'avgLikeCount';
export const performanceKeysMap: Record<GroupPerformanceKeys, string> = {
	avgLikeCount: '평균 좋아요 수(릴스/스타일)',
	avgCommentCount: '평균 댓글 수',
	avgViewCount: '평균 조회 수',
	avgEngagement: '평균 인게이지먼트',
	avgSentCount: '평균 발송 수(소셜비즈)',
	avgClickCount: '평균 클릭 수(소셜비즈)',
	totalAdvertisingCost: '총 광고 비용',
	CPV: 'CPV',
	CPE: 'CPE',
};

export const performanceKeys = Object.keys(performanceKeysMap) as GroupPerformanceKeys[];

const rankingOrderLabel = [
	'종합 성과',
	'좋아요 수(릴스)',
	'좋아요 수(스타일클립)',
	'댓글 수',
	'조회 수',
	'발송 수(소셜비즈)',
	'클릭 수(소셜비즈)',
] as const;
export type RankingOrderLabel = (typeof rankingOrderLabel)[number];
export const rankingOrderMapper: {
	label: RankingOrderLabel;
	value: keyof IDailyPerformanceDB;
}[] = [
	{ label: '종합 성과', value: 'totalPerformanceScore' },
	{ label: '좋아요 수(릴스)', value: 'reelsLikeCount' },
	{ label: '좋아요 수(스타일클립)', value: 'styleClipLikeCount' },
	{ label: '댓글 수', value: 'commentCount' },
	{ label: '조회 수', value: 'viewCount' },
	{ label: '발송 수(소셜비즈)', value: 'sentCount' },
	{ label: '클릭 수(소셜비즈)', value: 'clickCount' },
];
